// extracted by mini-css-extract-plugin
module.exports = {"hidden":"style_hidden__Oa-Yz","visible":"style_visible__2ASDm","container":"style_container__skJSW","certificate":"style_certificate__3bwmU"};